<div *ngIf="visible" class="top-container">
  <div class="top-bar-container">
    <div class="top-bar">
      <a class="env-link mobile-margin-left-10"
         href="{{intranetUrl}}"
         type="text">
        {{'MAIN_HEADER.INTRANET' | translate}}
      </a>
      <a class="env-link m-l-2"
         href="{{servicesUrl}}"
         type="text">
        {{'MAIN_HEADER.GWP' | translate}}
      </a>
      <a #language (click)="languageMenu.toggle($event)" class="menu-link language"
         type="text">{{ (user | async)?.locale?.name }}
        <span class="fa fa-caret-down"></span>
      </a>

      <p-overlayPanel #languageMenu [appendTo]="language">
        <wsd-locale-change [currentLocale]="(user | async)?.locale"
                          (onChange)="localeChanged()">
        </wsd-locale-change>
      </p-overlayPanel>

      <a class="menu-link language show-on-desktop" href="{{scoutOrgUrl}}" type="text">
        <span class="fa fa-caret-left"></span>
        {{'MAIN_HEADER.BACK_TO_SCOUT' | translate}}
      </a>
    </div>
  </div>
  <div class="top-navigation-container">
    <div class="top-navigation">
      <div class="p-grid p-align-center full-width">
        <div class="p-col logo">
          <a [routerLink]="['contacts']" class="logo">
            <img height="60" src="../assets/images/logo-white.png">
          </a>
        </div>
        <div class="p-col menu-holder">
          <wsd-main-menu class="show-on-desktop"></wsd-main-menu>
        </div>
        <img *ngIf="(user | async)?.id && !imageUrl && !imageSrc"
             class="p-col login-holder text-right top-navigation show-on-desktop"
             height="40" src="../assets/images/default-profile-image.png" width="40">
        <img *ngIf="(user | async)?.id && imageUrl && !imageSrc"
             class="p-col login-holder text-right top-navigation show-on-desktop login-image"
             height="40" [src]="imageUrl" width="40">
        <img *ngIf="(user | async)?.id  && imageSrc"
             class="p-col login-holder text-right top-navigation show-on-desktop login-image"
             height="40" [src]="imageSrc" width="40">
        <div class="p-col login-holder text-right top-navigation show-on-desktop">
          <p-overlayPanel #menu [appendTo]="login" styleClass="login-dropdown">
            <a *ngIf="(user | async)?.id"
               [routerLink]="['persons', (user | async)?.consultantId || 1, 'detail']" id="user_profile">
              {{ 'MAIN_HEADER.PROFILE_MENU.PROFILE' | translate }}
            </a>
            <a (click)="logout()" id="user_logout">{{ 'MAIN_HEADER.PROFILE_MENU.LOGOUT' | translate }}</a>
          </p-overlayPanel>
          <a #login (click)="menu.toggle($event)" *ngIf="(user | async)?.id" class="login" id="user_name" type="text">
            {{ (user | async)?.firstName}}
            <span class="fa fa-caret-down m-l-5"></span>
          </a>
          <a *ngIf="!(user | async)?.id" [href]="hostUrl + '/login'" class="login">
            {{ 'MAIN_HEADER.HEADER_LINK.LOGIN' | translate }}
          </a>
        </div>
      </div>
      <div class="show-on-mobile burger-menu">
        <i class="fa fa-bars" (click)="mobmenu.toggle($event)"></i>
      </div>
      <p-overlayPanel #mobmenu class="mobmenu show-on-mobile">
        <wsd-main-menu></wsd-main-menu>
        <a #login (click)="mobsubmenu.toggle($event)" *ngIf="!(user | async)?.id" class="moblogin"
           href="/login" id="user_mob_login">
          {{ 'MAIN_HEADER.HEADER_LINK.LOGIN' | translate }}
        </a>
        <a *ngIf="(user | async)?.id" (click)="mobsubmenu.toggle($event)" class="moblogin" id="user_mob_name">
          {{ (user | async)?.firstName}}
        </a>
        <p-overlayPanel #mobsubmenu [appendTo]="moblogin" styleClass="login-dropdown">
          <a (click)="closeMobileMenu()"
             *ngIf="(user | async)?.id"
             [routerLink]="['persons', (user | async)?.consultantId || 1, 'detail']"
             id="user_mob_profile">{{ 'MAIN_HEADER.PROFILE_MENU.PROFILE' | translate }}
          </a>
          <a (click)="logout()"
             *ngIf="(user | async)?.id"
             id="user_mob_logout">{{ 'MAIN_HEADER.PROFILE_MENU.LOGOUT' | translate }}</a>
        </p-overlayPanel>
      </p-overlayPanel>
    </div>
  </div>
  <wsd-breadcrumb></wsd-breadcrumb>
</div>
